import { Injectable } from '@angular/core';
import { unifiedMenu } from '../../../shared/nav';
import { displayedColumnsBroker, displayedColumnsSupplier, displayedColumnsLogistics, displayedColumnsCampaign, displayedColumnsCampaignBroker, displayedColumnsWorkshop, displayedColumnsTelemarketing, displayedColumnsStocks } from '../../../shared/display-columns';
import { getFilteredSettingRoutes } from '../../routes/settings-routing.module';
import { getFilteredClientsRoutes } from '../../routes/clients-routing.module';
import { getFilteredUsersRoutes } from '../../routes/users-routing.module';
import { getFilteredNotesRoutes } from '../../routes/notes-routing.module';
import { getFilteredInvoicesRoutes } from '../../routes/invoices-routing.module';
import { getFilteredReportsRoutes } from '../../routes/reports-routing.module';
import { getFilteredOrdersRoutes } from '../../routes/orders-routing.module';
@Injectable({
  providedIn: 'root'
})
export class AuthStateService {
  private role: string | null = null;
  private account_type: string | null = null;
  private name: string | null = null;
  private account_name: string | null = null;
  private user_reference: string | null = null;
  private account_reference: string | null = null;
  private expires_in: number | null = null;
  private selectedSupplier: any | null = null;

  getRole(): string | null {
    const access_token = localStorage.getItem('access_token');

    if (access_token) {
      const userData = this.parseJwt(access_token);
      this.role = userData.role;
    }
    return this.role || null;
  }

  getName(): string | null {
    const access_token = localStorage.getItem('access_token');
    const userData = this.parseJwt(access_token || '');
    if (access_token) {
      this.name = userData.name;
    }
    return this.name;
  }
  getAccountCountry(): string | null {
    const access_token = localStorage.getItem('access_token');
    const userData = this.parseJwt(access_token || '');
    if (access_token) {
      return userData.account_country || null;
    }
    return null;
  }

  getUserReference(): string | null {
    const access_token = localStorage.getItem('access_token');
    const userData = this.parseJwt(access_token || '');
    if (access_token) {
      this.user_reference = userData.user_reference;
    }
    return this.user_reference;
  }

  getAccountReference(): string | null {
    const access_token = localStorage.getItem('access_token');
    const userData = this.parseJwt(access_token || '');
    if (access_token) {
      this.account_reference = userData.account_reference;
    }
    return this.account_reference;
  }

  getAccountName(): string | null {
    const access_token = localStorage.getItem('access_token');
    const userData = this.parseJwt(access_token || '');
    if (access_token) {
      this.account_name = userData.account_name;
    }
    return this.account_name;
  }



  getAccountType(): string | null {
    const access_token = localStorage.getItem('access_token');
    const userData = this.parseJwt(access_token || '');
    if (access_token) {
      this.account_type = userData.account_type;
    }
    return this.account_type;
  }

  getMenuItems() {
    const role = this.getRole();
    const accountType = this.getAccountType();
    const accountName = this.getAccountName();
    return unifiedMenu
      .map(item => {
        // C. Digitales: solo visible para brokers de idoneo.com
        if (item.key === 't-digital' && accountType === 'broker' && accountName !== 'idoneo.com') {
          return null;
        }
        // Si tiene hijos, filtra los hijos recursivamente
        if (item.children) {
          const filteredChildren = item.children.filter(child => {
            const roles = child.role;
            const accounts = child.account_type;
            const roleAllowed = !roles || roles.includes(role || '');
            const accountAllowed = !accounts || accounts.includes(accountType || '');
            return roleAllowed && accountAllowed;
          });
          // Si hay hijos válidos, incluye el padre con esos hijos
          if (filteredChildren.length > 0) {
            return { ...item, children: filteredChildren };
          }
          // Si no hay hijos válidos, no incluye el padre
          return null;
        } else {
          // Si no tiene hijos, filtra por role y account_type
          const roles = item.role;
          const accounts = item.account_type;
          const roleAllowed = !roles || roles.includes(role || '');
          const accountAllowed = !accounts || accounts.includes(accountType || '');
          return roleAllowed && accountAllowed ? item : null;
        }
      })
      .filter(Boolean); // Elimina los nulls
  }

  getRoutesItems(): any[] {
    const role = this.getRole();
    const accountType = this.getAccountType();

    const settingsRoutes = getFilteredSettingRoutes(accountType || '', role || '');
    const clientsRoutes = getFilteredClientsRoutes(accountType || '', role || '');
    const usersRoutes = getFilteredUsersRoutes(accountType || '', role || '');
    const notesRoutes = getFilteredNotesRoutes(accountType || '', role || '');
    const invoicesRoutes = getFilteredInvoicesRoutes(accountType || '', role || '');
    const reportsRoutes = getFilteredReportsRoutes(accountType || '', role || '');
    const ordersRoutes = getFilteredOrdersRoutes(accountType || '', role || '');

    return [
      ...clientsRoutes,
      ...invoicesRoutes,
      ...notesRoutes,
      ...ordersRoutes,
      ...reportsRoutes,
      ...usersRoutes,
      ...settingsRoutes,
    ];

  }


  /**
   * Pantalla inicial de cada rol. Unica fuente de verdad del redirect por
   * rol: la usan AuthGuard, el login y RoleAccountGuard. Devuelve siempre una
   * ruta que ese rol y account_type tienen permitida en el routing, o
   * '/not-found' si la combinacion no tiene ninguna pantalla asignada.
   */
  getRedirectUrl(): string {
    const role = this.getRole();
    const accountType = this.getAccountType();

    if (role === 'Workshop') {
      return '/orders/registering';
    } else if (role === 'Logistics') {
      return '/orders/after-sales-factory';
    } else if (role === 'Telemarketing') {
      return '/orders/telemarketing-pending';
    } else if (role === 'Sales' && accountType === 'broker') {
      return '/orders/sqls';
    } else if (role === 'Agent' && accountType === 'broker') {
      return '/orders/sqls';
    } else if (role === 'Pre-sales') {
      // Pre-sales es un rol de supplier; /orders/drafts exige broker, asi que
      // su pantalla inicial es el primer item de su menu.
      return accountType === 'broker' ? '/orders/drafts' : '/orders/rejected';
    } else if (accountType === 'broker') {
      return '/orders/drafts';
    } else {
      return '/orders/contracts';
    }
  }
  getDisplayedColumns(typeOrders: string): string[] {
    const role = this.getRole();
    const accountType = this.getAccountType();
    let returnedColumns: string[] = [];
    if (typeOrders === 'telemarketing-pending') {
      returnedColumns = displayedColumnsTelemarketing;
    }
    if (role === 'Logistics') {
      returnedColumns = displayedColumnsLogistics;
    } else if (role === 'Telemarketing') {
      returnedColumns = displayedColumnsTelemarketing;
    } else if (accountType === 'supplier' && role === 'Workshop') {
      returnedColumns = displayedColumnsWorkshop;
    } else if (accountType === 'broker') {
      returnedColumns = displayedColumnsBroker;
    } else {
      returnedColumns = displayedColumnsSupplier;
    }

   /*  if (typeOrders != 'fronzen' && typeOrders != 'cancelled') {
      // Remover old_stage si está presente
      const idx = returnedColumns.indexOf('old_stage');
      if (idx !== -1) {
        returnedColumns.splice(idx, 1);
      }
    } */
    return returnedColumns;
  }

  getCampaignColumns(): string[] {
    const role = this.getRole();
    const accountType = this.getAccountType();
    return role === 'Supplier' ? displayedColumnsCampaign : displayedColumnsCampaignBroker;
  }

  getStocksColumns(): string[] {
    const role = this.getRole();
    const accountType = this.getAccountType();
    return displayedColumnsStocks;
  }

  setSelectedSupplier(supplier: any): void {
    this.selectedSupplier = supplier;
  }

  getSupplierTax(): any | null {
    const country = this.selectedSupplier?.country || this.getAccountCountry();

    switch (country) {
      case 'ES':
      case 'es':
        return 0.21
      case 'ES-CN':
      case 'es-cn':
        return 0.15
      case 'PT':
      case 'pt':
        return 0.23
      case 'IT':
      case 'it':
        return 0.22
      default:
        return 0;
    }
  }
  private parseJwt(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }
}

